import { Component, OnInit, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { erreursLibelle } from '../questionnaire.metadata';

@Component({
  selector: 'bis-affiche-erreurs',
  templateUrl: './affiche-erreurs.component.html',
  styleUrls: ['./affiche-erreurs.component.css']
})
export class AfficheErreursComponent implements OnInit {
  @Input()
  erreurs: ValidationErrors = {};
  erreursMessages: Map<string, string> = erreursLibelle;

  constructor() {}

  ngOnInit() {
  }

  get clesErreurs(): string[] {
    return Object.keys(this.erreurs);
  }

}
